module.exports = "pegasus_template/assets/5px.png";